export class ImageLightboxTransformHelper {
  static readonly MIN_ZOOM = 0.2;
  static readonly MAX_ZOOM = 10;
  static readonly WHEEL_ZOOM_STEP = 0.1;
  static readonly DRAG_THRESHOLD_PX = 5;

  public static clampZoom(zoom: number): number {
    return Math.min(Math.max(zoom, ImageLightboxTransformHelper.MIN_ZOOM), ImageLightboxTransformHelper.MAX_ZOOM);
  }

  public static getTouchDistance(touchA: Touch, touchB: Touch): number {
    const deltaX = touchA.clientX - touchB.clientX;
    const deltaY = touchA.clientY - touchB.clientY;
    return Math.hypot(deltaX, deltaY);
  }

  public static snapPanOffset(value: number): number {
    return Math.round(value);
  }

  public static snapZoom(value: number): number {
    return Math.round(value * 1000) / 1000;
  }

  public static buildTransformStyle(
    zoom: number,
    panX: number,
    panY: number,
  ): { transform: string } {
    const snappedPanX = ImageLightboxTransformHelper.snapPanOffset(panX);
    const snappedPanY = ImageLightboxTransformHelper.snapPanOffset(panY);
    const snappedZoom = ImageLightboxTransformHelper.snapZoom(zoom);

    return {
      transform: `translate3d(${snappedPanX}px, ${snappedPanY}px, 0) scale(${snappedZoom})`,
    };
  }

  public static applyWheelZoom(currentZoom: number, deltaY: number): number {
    const delta = deltaY > 0 ? -ImageLightboxTransformHelper.WHEEL_ZOOM_STEP : ImageLightboxTransformHelper.WHEEL_ZOOM_STEP;
    return ImageLightboxTransformHelper.clampZoom(currentZoom + delta);
  }

  public static applyPinchZoom(startZoom: number, startDistance: number, currentDistance: number): number {
    if (startDistance === 0) {
      return startZoom;
    }

    return ImageLightboxTransformHelper.clampZoom(startZoom * (currentDistance / startDistance));
  }

  public static hasExceededDragThreshold(
    startX: number,
    startY: number,
    currentX: number,
    currentY: number,
  ): boolean {
    return Math.hypot(currentX - startX, currentY - startY) > ImageLightboxTransformHelper.DRAG_THRESHOLD_PX;
  }
}
